var ltr6_module_grid_filters = (function (ltr6_module_grid_filters) {

    var button;
    var menu;

    ltr6_module_grid_filters.init = function(){
      button = $('#ltr6-wrapper .ltr6-grid-filters .ltr6-filter-toggle-button');
      menu = $('#ltr6-wrapper .ltr6-grid-filters .ltr6-grid-filters-menu');


      // -----------------
      // open close button
      // -----------------
      $('#ltr6-wrapper .ltr6-grid-filters').on('click', '.ltr6-filter-toggle-button', function(event) {
        event.preventDefault();
        if(!menu.hasClass('active')){
          ltr6_module_grid_filters.openGridFilterMenu();
        } else {
          ltr6_module_grid_filters.closeGridFilterMenu();
        }
      });


      // -----------------
      // click a filter
      // -----------------
      $('#ltr6-wrapper .ltr6-grid-filters-menu label').on('click', 'input', function(event) {
        // event.preventDefault();
        // var radarInstance = $(this).closest();
        var radarInstance;
        var otherRadarInstance;
        if($(this).closest('.ltr6-interactive-radar-wrapper').length){
          radarInstance = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper');
          otherRadarInstance = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper');
        } else {
          radarInstance = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper');
          otherRadarInstance = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper');
        }

        // console.log(event.target);
        var item = $(this);
        var filter = item.parent().attr('data-filter-name');
        var filterName = item.parent().find('.ltr6-label').text();

        // console.log('item',item);
        // console.log('filter',filter);


        if(filter=='all'){
          var ch = '';
          if(item.is(":checked")){
            ch = 'checked';
          }
          $('.ltr6-grid-filters-menu input',radarInstance).prop('checked',ch);
        }

        // group
        if(filter=='social_and_business_trends'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="technology_trends"] input',radarInstance).prop('checked','');
          }
        }
        if(filter=='technology_trends'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="social_and_business_trends"] input',radarInstance).prop('checked','');
          }
        }

        // group
        if(filter=='within_5_years_realization'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="5_to_10_years_realization"] input',radarInstance).prop('checked','');
          }
        }
        if(filter=='5_to_10_years_realization'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="within_5_years_realization"] input',radarInstance).prop('checked','');
          }
        }

        // group
        if(filter=='lower_impact'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="higher_impact"] input',radarInstance).prop('checked','');
          }
        }
        if(filter=='higher_impact'){
          if(item.is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="lower_impact"] input',radarInstance).prop('checked','');
          }
        }

        if(item.is(":checked")){
          ltr6_module_analytics.tracking_adobe(filterName,'Button','Click','Grid Filter');
          ltr6_module_analytics.tracking_decibel(filterName,'Button','Click','Grid Filter');
        }


        $.each($('.ltr6-grid-filters-menu label input',radarInstance), function(index, val) {
          var filter = $(this).parent().attr('data-filter-name');
          if($(this).is(":checked")){
            $('.ltr6-grid-filters-menu label[data-filter-name="'+filter+'"] input',otherRadarInstance).prop('checked','checked');
          } else {
            $('.ltr6-grid-filters-menu label[data-filter-name="'+filter+'"] input',otherRadarInstance).prop('checked','');
          }
        });


        doGridFilters(radarInstance);
        doGridFilters(otherRadarInstance);

        // },10);
      });

      // -----------------
      // do filters
      // -----------------

      function doGridFilters(radarInstance){
        var filters = $('.ltr6-grid-filters-menu input',radarInstance);
        var activeCount = 0;
        $.each(filters, function(index, val) {
          if($(this).parent().attr('data-filter-name')!='all' && $(this).is(":checked")) {
            activeCount ++;
          }
        });

        if(activeCount==6){
          $('.ltr6-grid-filters-menu label[data-filter-name="all"] input',radarInstance).prop('checked','checked');
        } else {
          $('.ltr6-grid-filters-menu label[data-filter-name="all"] input',radarInstance).prop('checked','');
        }

        if(activeCount>0){
          $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-clear-filters').show();
        } else {
          $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-clear-filters').hide();
        }

        // if(activeCount==0){
        // }
        var html = '';
        if(activeCount>0) html = '('+activeCount+')';
        $('.ltr6-grid-filters .ltr6-active-filters-count',radarInstance).html(html);
        // console.log('activeCount',activeCount);
        ltr6_module_radar.apply_filters(radarInstance);
      }

      // -----------------
      // reset filters
      // -----------------
      $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-grid-filters-menu .ltr6-clear-filters').on('click', function(event) {
        event.preventDefault();
        var radarInstance = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper');
        var otherRadarInstance = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper');
        resetFilters(radarInstance);
        resetFilters(otherRadarInstance);
      });
      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-grid-filters-menu .ltr6-clear-filters').on('click', function(event) {
        event.preventDefault();
        var radarInstance = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper');
        var otherRadarInstance = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper');
        resetFilters(radarInstance);
        resetFilters(otherRadarInstance);
      });

      function resetFilters(radarInstance){
        var filters = $('.ltr6-grid-filters-menu input',radarInstance);
        $.each(filters, function(index, val) {
          $(this).prop('checked','');
        });
        doGridFilters(radarInstance);
        ltr6_module_grid_filters.closeGridFilterMenu();
      }

      // -----------------
      // apply and close
      // -----------------
      $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-grid-filters-menu .ltr6-apply-filters').on('click', function(event) {
        event.preventDefault();
        ltr6_module_grid_filters.closeGridFilterMenu();
        // doGridFilters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      });
      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-grid-filters-menu .ltr6-apply-filters').on('click', function(event) {
        event.preventDefault();
        ltr6_module_grid_filters.closeGridFilterMenu();
        // doGridFilters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
      });


    }; //end init


    ltr6_module_grid_filters.openGridFilterMenu = function(){
      button.addClass('active');
      menu.addClass('active');
      ltr6_module_radar.closeMobileFilterMenu();
      setTimeout(function(){
        $('body').on('click', closeMenuOnOutsideClick);
      },0);
      ltr6_module_analytics.tracking_adobe('Open Grid Filter Menu','Button','Click','Grid Filter Menu');
      ltr6_module_analytics.tracking_decibel('Open Grid Filter Menu','Button','Click','Grid Filter Menu');
    }

    ltr6_module_grid_filters.closeGridFilterMenu = function(){
      button.removeClass('active');
      menu.removeClass('active');
      $('body').off('click', closeMenuOnOutsideClick);
    }


    function closeMenuOnOutsideClick(e){
      // console.log(e.target);
      if($(e.target).closest('.ltr6-grid-filters-menu').length) return;
      ltr6_module_grid_filters.closeGridFilterMenu();
      $('body').off('click', closeMenuOnOutsideClick);
    }


    return ltr6_module_grid_filters;
}(ltr6_module_grid_filters || {}));